<script>
  import { Line } from 'vue-chartjs'
  import Colors from '../../mixins/Colors'
  import moment from 'moment-es6'

  export default {
    name: 'resource-graph',
    extends: Line,
    props: {
      active: {
        type: Boolean,
        required: true
      },
      resource: {
        type: Object,
        required: true
      }
    },
    mixins: [Colors],
    data () {
      return {
        initiallyRendered: false
      }
    },
    methods: {
      renderData () {
        this.initiallyRendered = true
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        this.renderChart({
          labels: this.resource.resourceUsages.map(res => moment(res.resourceUsageDate).format('DD/MM')),
          datasets: [
            {
              label: this.resource.resourceIdentifier,
              fill: false,
              borderColor: this.lightenColor(this.$vuetify.theme.secondary, 2),
              data: this.resource.resourceUsages.map(res => res.resourceCount)
            }
          ]
        }, {
          legend: {
            display: false,
            position: 'bottom'
          },
          animation: {
            animateScale: true
          },
          responsive: true,
          maintainAspectRatio: true,
          scales: {
            yAxes: [{
              ticks: {
                suggestedMin: 0,
                suggestedMax: 5,
                userCallback (label, index, labels) {
                  if (Math.floor(label) === label) {
                    return label
                  }
                }
              }
            }],
            xAxes: [{
              ticks: {
                minRotation: 0,
                maxRotation: 0
              }
            }]
          },
          tooltips: {
            callbacks: {
              label () {
                return null
              }
            }
          }
        })
      }
    },
    computed: {},
    watch: {
      active (value) {
        if (value && !this.initiallyRendered) {
          this.renderData()
        }
      },
      resource () {
        this.renderData()
      }
    },
    mounted () {
      if (this.active) {
        this.renderData()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resources/ResourceGraph.vue